export default "__VITE_PUBLIC_ASSET__53987d1b__"